"use client";

import { CapabilityOverviewSection } from "@/components/sections/capability-overview";
import { capabilityOverview } from "@/lib/data/services-brand-protection-augmentation";

export function CapabilityOverview() {
  return (
    <CapabilityOverviewSection
      primaryAccent={"var(--color-cyan)"}
      secondaryAccent={"var(--color-purple)"}
      tertiaryAccent={"var(--color-emerald)"}
      eyebrow={capabilityOverview.eyebrow}
      title={capabilityOverview.title}
      intro={capabilityOverview.intro}
      frameworks={capabilityOverview.frameworks}
      biasLevels={capabilityOverview.biasLevels}
      variantDimensions={capabilityOverview.variantDimensions}
      localization={capabilityOverview.localization}
    />
  );
}
